import { KeyboardEvent, KeyboardEventHandler } from "react"

export const onPressEnterSubmitHandler = (
  onSubmit: () => void,
  isDisabled: boolean
): KeyboardEventHandler<HTMLInputElement> => {
  return (e: KeyboardEvent<HTMLInputElement>) => {
    e.stopPropagation()
    if (!isDisabled && e.key === "Enter") {
      e.preventDefault()
      onSubmit()
    }
  }
}
